import { SuggestedChangesPayload } from "PFCore/services/bookings_suggested_changes";
const ROOT_KEY = "suggested_changes";

export const suggestedChangesKeys = {
  suggestedChanges: (payload: SuggestedChangesPayload | null) => [ROOT_KEY, payload]
};
